class Movie {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let scrollPosition = 0;

    $('.js-movie-trigger').on('click', function() {
      // 現在のスクロール位置を保存
      scrollPosition = $(window).scrollTop();
      
      // モーダルを開く
      $('.js-movie-modal').toggleClass('is-active');
      $('body').addClass('no_scroll').css({
        'top': -scrollPosition + 'px'
      });
    
      if ($('.js-movie-modal').hasClass('is-active')) {
        $('.js-movie-video').get(0).play();
      }
    });
    
    $('.js-movie-back').on('click', function(event) {
      event.preventDefault(); // デフォルトの動作を防ぐ
    
      // 動画を停止し、最初に戻す
      $('.js-movie-video').get(0).pause();
      $('.js-movie-video').get(0).currentTime = 0;
    
      // no_scrollクラスを外してスクロール位置を復元
      $('body').removeClass('no_scroll').css({
        'top': ''
      });
      window.scrollTo(0, scrollPosition);
    
      // モーダルを閉じる
      $('.js-movie-modal').removeClass('is-active');
    });
    
  }
}